// Fokusregeln des Drawers (Modal.tsx bringt den Fokus beim Öffnen ebenso hinein und stellt ihn beim Schließen zurück).
// Die Tab-Regel steht hier als reine Funktion, damit `node --test` sie ohne DOM prüfen kann.

/** Fokussierbar per Tastatur; `[tabindex="-1"]` gehört nicht dazu (nur per Skript erreichbar). */
export const FOKUSSIERBAR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'

/** Wohin springt Tab (`shift`: Umschalt+Tab), damit der Fokus im Overlay bleibt? `items` = die fokussierbaren Elemente
 *  in Tab-Reihenfolge, `active` = das Element mit Fokus (null/außerhalb der Liste: das Overlay selbst, der Body).
 *  Gibt das Ziel zurück — der Aufrufer unterdrückt dann das Standardverhalten — oder `undefined`, wenn der Browser
 *  selbst richtig weitergeht (mitten in der Liste) oder es nichts zum Springen gibt (leere Liste: Aufrufer hält den Fokus
 *  am Overlay). */
export function trapTarget<T>(items: readonly T[], active: T | null | undefined, shift: boolean): T | undefined {
  if (items.length === 0) return undefined
  const i = active == null ? -1 : items.indexOf(active)
  if (i === -1) return shift ? items[items.length - 1] : items[0]
  if (shift && i === 0) return items[items.length - 1]
  if (!shift && i === items.length - 1) return items[0]
  return undefined
}

/** Die sichtbaren, fokussierbaren Nachfahren von `root` in Dokumentreihenfolge. */
export function fokussierbare(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOKUSSIERBAR)).filter(el => el.getClientRects().length > 0)
}

/** Tab / Umschalt+Tab im Overlay `sheet`: der Fokus bleibt darin. Ohne Bedienelement bleibt er am Blatt selbst
 *  (`tabIndex={-1}`); sonst springt er vom letzten zum ersten und umgekehrt — auch von außerhalb zurück hinein. */
export function haltTab(sheet: HTMLElement, e: KeyboardEvent): void {
  const items = fokussierbare(sheet)
  if (items.length === 0) { e.preventDefault(); sheet.focus(); return }
  const aktiv = document.activeElement as HTMLElement | null
  const ziel = trapTarget(items, aktiv && aktiv !== sheet && sheet.contains(aktiv) ? aktiv : null, e.shiftKey)
  if (ziel) { e.preventDefault(); ziel.focus() }
}
